module.exports = "https://www.gc-qa.gnp.com.mx/e187da37ab28c5c7f5ea8d340cf1a530.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-6.png
// module id = 954
// module chunks = 0 1